"use client";
import { LayoutStylesType } from "@/util/query/general-styles-query";
import React, { createContext, ReactNode, useEffect, useState, useContext } from "react";

export type LayoutStylesInput = Partial<LayoutStylesType> | null | undefined;

const LayoutStyleContext = createContext<LayoutStylesType>({} as LayoutStylesType);

export const LayoutStyleProvider = ({
    children,
    layoutStyle,
}: {
    children: ReactNode;
    layoutStyle?: LayoutStylesInput;
}) => {
    const [data, setData] = useState<LayoutStylesType>({
        buttonRadiusTopLeft: 6,
        buttonRadiusTopRight: 6,
        buttonRadiusBottomLeft: 6,
        buttonRadiusBottomRight: 6,
    });

    useEffect(() => {
        if (!layoutStyle) return;

        setData((prev) => ({
            buttonRadiusTopLeft: layoutStyle.buttonRadiusTopLeft ?? prev.buttonRadiusTopLeft,
            buttonRadiusTopRight: layoutStyle.buttonRadiusTopRight ?? prev.buttonRadiusTopRight,
            buttonRadiusBottomLeft: layoutStyle.buttonRadiusBottomLeft ?? prev.buttonRadiusBottomLeft,
            buttonRadiusBottomRight: layoutStyle.buttonRadiusBottomRight ?? prev.buttonRadiusBottomRight,
        }));
    }, [layoutStyle]);

    return <LayoutStyleContext.Provider value={data}>{children}</LayoutStyleContext.Provider>;
};

export default LayoutStyleContext;

/** Optional convenience hook (like useContext wrapper) */
export const useLayoutStyle = () => useContext(LayoutStyleContext);

/** Optional helper to use directly in style={{ borderRadius: ... }} */
export const borderRadiusShorthand = (s: LayoutStylesType) =>
    `${s.buttonRadiusTopLeft}px ${s.buttonRadiusTopRight}px ${s.buttonRadiusBottomRight}px ${s.buttonRadiusBottomLeft}px`;
